import React, { useRef } from "react";

const SaleReceipt = () => {
  const receiptRef = useRef(null);

  const handlePrint = () => {
    const receiptContent = receiptRef.current.innerHTML;

    // Open a new window
    const printWindow = window.open(
      "",
      "_blank",
      "width=300,height=600,left=500,top=100"
    );

    // Write the receipt content to the new window
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Receipt</title>
          <style>
            body {
              font-family: "Courier New", monospace;
              text-align: center;
              padding: 10px;
            }
            .receipt {
              width: 58mm;
              max-width: 58mm;
              padding: 10px;
              border: 1px solid #000;
            }
            table {
              width: 100%;
              border-collapse: collapse;
            }
            td {
              padding: 5px;
              text-align: left;
            }
            hr {
              border: none;
              border-top: 1px dashed #000;
              margin: 5px 0;
            }
          </style>
        </head>
        <body onload="window.print(); setTimeout(() => window.close(), 1000);">
          <div class="receipt">${receiptContent}</div>
        </body>
      </html>
    `);

    printWindow.document.close(); // Close document writing
  };

  return (
    <div className="receipt-container">
      <div ref={receiptRef} className="receipt">
        <h2>Life Chemist Ltd</h2>
        <p>Date: {new Date().toLocaleDateString()}</p>
        <hr />
        <table>
          <tbody>
            <tr>
              <td>Item 1</td>
              <td>2 x $5</td>
              <td>$10</td>
            </tr>
            <tr>
              <td>Item 2</td>
              <td>1 x $7</td>
              <td>$7</td>
            </tr>
          </tbody>
        </table>
        <hr />
        <p><strong>Total: $17</strong></p>
        <p>Thank you for your purchase!</p>
      </div>
      <button onClick={handlePrint}>Print Receipt</button>
    </div>
  );
};

export default SaleReceipt;
